import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { Building } from '@wm-front/admin/graphql'
import { TooltipDirective } from '../../directives/tooltip/tooltip.directive'

/** What the AddressCellComponent uses on a building entity */
type MinimalBuilding = Pick<Building, 'name' | 'id'> & {
  location: Pick<
    NonNullable<Building['location']>,
    'streetAddress' | 'zipcode'
  > & {
    city?: Pick<NonNullable<Building['location']>['city'], 'name'>
  }
}

@Component({
  selector: 'wm-front-address-cell',
  templateUrl: './address-cell.component.html',
  styleUrls: ['./address-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TooltipDirective],
})
export class AddressCellComponent {
  /** The device type to display */
  @Input() public building: MinimalBuilding
}
